module.exports = __webpack_public_path__ + "static/media/26UNRWA15.9a1cd346.jpg";